import { SET_IS_LOGGED_IN, SET_PASSWORD,SET_BEARER_TOKEN, SET_USERNAME } from './userTypes';

const initialState = {
  isLoggedIn: false,
  username: "",
  password:"",
  bearerToken: null
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_IS_LOGGED_IN:
      return {
        ...state,
        isLoggedIn: payload.isLoggedIn
      };
    case SET_BEARER_TOKEN:
      return {
        ...state,
        bearerToken: payload.bearerToken
      };
    case SET_USERNAME:
      return {
        ...state,
        username: payload.username
      };
    case SET_PASSWORD:
      return {
        ...state,
        password: payload.pass
      }


    default:
      return state;
  }
};

export default reducer;
